// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__R0wFF","name":"Footer_name__U3hoc","links":"Footer_links__z0r93"};